module.exports = __webpack_public_path__ + "img/img_join_06.d7e710b3.jpg";